export default __webpack_public_path__ + "static/media/dd4.723a5a3a.jpg";